import React, { useEffect } from 'react'
import { Spin } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import Actions from '../../../../actions'
import { routes } from '../../../../consts'
import './WalnutPage.css'
import $t from '../../../../i18n'
import { t } from '@transifex/native'

const WalnutPage = () => {
  const dispatch = useDispatch()

  const { walnutAppToken, walnutData, walnutUrl, selectedPlan } = useSelector(
    state => state.payment
  )
  useEffect(() => {
    window.addEventListener('message', onSuccess)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onSuccess = e => {
    // do nothing if the origin is not walnutUrl
    if (e.origin !== walnutUrl) {
      return
    }

    if ('Successfully created a payment plan.' === e.data) {
      dispatch(Actions.createAction(Actions.REDIRECT_TO_PAYMENT_SUCCESS))
    } else if (
      'Application has been declined.' === e.data ||
      'Application has been sent for manual review.' === e.data
    ) {
      onExit()
    }
  }

  const onExit = () => {
    dispatch(
      Actions.createAction(
        Actions.NAVIGATED_TO,
        routes.PAYMENT_PLAN.replace(':id', selectedPlan?.id)
      )
    )
  }

  if (!walnutAppToken) {
    onExit()
  } else {
    return (
      <>
        <div className="walnut-in-app-plan">
          <div className="walnut-in-app-plan-name">
            {t(selectedPlan?.plan_name)}
          </div>
          <div className="walnut-in-app-plan-price">
            ${selectedPlan?.walnut_price?.price}{' '}
            {$t('pages.walnutInfo.perMonth')}
          </div>
        </div>
        <iframe
          allowFullScreen={true}
          allowpaymentrequest="true"
          onError={() =>
            dispatch(Actions.createAction(Actions.REDIRECT_TO_PAYMENT_CANCEL))
          }
          frameBorder="0"
          style={{ width: '100%', height: '100%', border: 'none' }}
          title="Walnut"
          id="walnutIframe"
          src={`${walnutUrl}/welcome?applicationToken=${walnutAppToken}&requestedAmount=${walnutData?.requestedAmount}`}
          sandbox="allow-scripts allow-same-origin allow-top-navigation allow-forms allow-popups allow-pointer-lock"
        ></iframe>
      </>
    )
  }
  return <Spin size="large" />
}

export default WalnutPage
